import { render, staticRenderFns } from "./InstaSlider.vue?vue&type=template&id=0349fb3c"
import script from "./InstaSlider.vue?vue&type=script&lang=js"
export * from "./InstaSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports